module.exports = __webpack_public_path__ + "img/brb.9873885f.svg";